import React from "react";

import { useTooltipContent } from "./useTooltipContent";
import { useBarChartContext } from "../../BarChartProvider";
import { Granularity } from "../../../../../helpers/reports.helper.types";
import { TimeRange } from "../../../../time/timeRange/TimeRange";

import "./BarChartTooltip.scss";

export const BarChartTooltip = ({ container }) => {
  const { period } = useBarChartContext();
  const tooltip = useTooltipContent(container);

  if (!tooltip) return null;

  const {
    activeSlice: time,
    activeCoordinate: { x },
  } = tooltip;

  return (
    <div className="report-tooltip" style={{ left: Math.ceil(x) }}>
      <TimeRange
        period={period}
        start={time}
        end={time + Granularity[period]}
      />
    </div>
  );
};
